import PeerConnectionBadge from './PeerConnectionBadge';
import React from 'react';
import Header from './header';

import { URL, URL_SOCKET, TURN_1, TURN_2, TURN_3, TURN_4, hasSocketApiEncryptionKey } from '../variables';
import { connect } from 'react-redux';
import { mudarUser, logout, mudarProcesso, mudarSocket, mudarSalaScreen, mudarChatOpen, changeShowCall, changeConnect } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';
import io from 'socket.io-client';
import secureSocket from '../utils/secureSocket';

import moment from 'moment-timezone';
import Chat from './Chat';
import ReportAction from './ReportAction';
import ChatIndividual from './ChatIndividual';
import ReactTooltip from 'react-tooltip';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import HeaderSala from './HeaderSala';
import { getRoom, getRooms } from '../services/requests';
import SolicitacaoModal from './SolicitacaoModal';
import SweetAlert from 'react-bootstrap-sweetalert';
import MeetingRoom from "./Meet";
import ListStudents from './ListStudents';
import ValidationModal from './ValidationModal';

class Sala extends React.Component {

    constructor(props) {
        super(props);
        this.external_camera_status = {};
        this.external_camera_status_revision = 0;
        this.peer_version = 0;
        this.state = {
            msg: '',
            loading_screen: true,
            redirect: false,
            path: '/',
            salas: [],
            sala_select: {},
            number_online: [],
            alunos_m: [],
            comunicados: [],
            salas_ids: [],
            full_screen_open: false,
            aluno_fullscreen: -1,
            candidatos: [],
            width_candidato_box: 0,
            height_candidato_box: 0,
            alunoChat_select: {},
            candidato_selectAcao: {},
            show_modal_action: false,
            show_modal_chat_geral: false,
            show_modal_request: false,
            times_reconects: {},
            loading_sala: false,
            loading_alter_video: {},
            video_blink: {},
            video_blink_movement: {},
            number_line: [],
            requestSelect: null,
            message_warning: null,
            loadings_pause: {},
            show_chat_meet: false,
            list_open: false,
            open_validation_modal: false,
            validation_student_id: null,
            loadings_request_validations: {},
            hide_btns: {},
            mensagens_notificacao: {},
            validacao_notificacao: {},
            saida_tela_notificacao: {},
            salas_numbers: {},
            chat_open_geral: false,
            show_notification:true,
            show_disconnected:false,
            external_camera_status_version: 0,
            candidate_alert_details_open: {},
            show_candidate_ip: true

        }
        this.fullscreen_ref = React.createRef();
        this.audio_context_peers = {}
        this.list_peers = {};
        this.configuration = {
            iceServers: [
                { urls: "stun:stun.1.google.com:19302" },
                {
                    'urls': 'turn:turnserver.ontest.com.br:3478?transport=udp',
                    'credential': 'Coconuts69341228#',
                    'username': 'onteste_projetos'
                },
                // {
                //     'urls': 'turn:' + TURN_1 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // },
                // {
                //     'urls': 'turn:' + TURN_2 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // },
                // {
                //     'urls': 'turn:' + TURN_3 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // },
                // {
                //     'urls': 'turn:' + TURN_4 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // }

            ],
            sdpSemantics: 'unified-plan'
        };
        this.unmont = false;
        this.good_quality_student = {};
        this.timeout_request = {}
        this.last_alter_external = {}
        // this.videoRef=null;
    }
    handle_offer_sdp(offer) {
        let sdp = offer.sdp.split('\r\n');//convert to an concatenable array
        let new_sdp = '';
        let position = null;
        sdp = sdp.slice(0, -1); //remove the last comma ','
        for (let i = 0; i < sdp.length; i++) {//look if exists already a b=AS:XXX line
            if (sdp[i].match(/b=AS:/)) {
                position = i; //mark the position
            }
        }
        if (position) {
            sdp.splice(position, 1);//remove if exists
        }
        for (let i = 0; i < sdp.length; i++) {
            if (sdp[i].match(/m=video/)) {//modify and add the new lines for video
                new_sdp += sdp[i] + '\r\n' + 'b=AS:' + '24' + '\r\n';
            }
            else {
                if (sdp[i].match(/m=audio/)) { //modify and add the new lines for audio
                    new_sdp += sdp[i] + '\r\n' + 'b=AS:' + 48 + '\r\n';
                }
                else {
                    new_sdp += sdp[i] + '\r\n';
                }
            }
        }
        return new_sdp; //return the new sdp
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }


    componentDidMount() {
        // document.getElementById('header_page').classList.add('mouse_come_here');
        // this.mouseEvent = (function (e) {
        //     if (e.clientY < 70 && this.props.chat_open == false) {
        //         document.getElementById('header_page').classList.add('visible');
        //         document.getElementById('header_page').classList.remove('mouse_come_here');
        //     }
        //     else {
        //         document.getElementById('header_page').classList.remove('visible');
        //         document.getElementById('header_page').classList.add('mouse_come_here');
        //     }
        // }).bind(this);
        // window.addEventListener('mousemove', this.mouseEvent);

        let width_candidato_box = window.innerWidth / 6;
        let height_candidato_box = (window.innerHeight - 0) / 4;
        this.setState({ width_candidato_box, height_candidato_box });
        this.resizeEvent = (function (event) {
            console.log(window.innerWidth);
            console.log(window.innerHeight);
            let width_candidato_box = window.innerWidth / 6;
            if (this.props.chat_open != -1 || this.state.list_open == true) {
                width_candidato_box = (window.innerWidth - 300) / 6;
            }
            let height_candidato_box = (window.innerHeight - 0) / 4;
            this.setState({ width_candidato_box, height_candidato_box });

            console.log(event);
        }).bind(this);
        window.addEventListener('resize', this.resizeEvent, true);

        this.props.mudarSalaScreen(true);
        this.get_salas(this.props.match.params.id);

    }

    componentDidUpdate(props, state) {
        if (props.chat_open != this.props.chat_open || this.state.list_open != state.list_open) {
            let width_candidato_box = window.innerWidth / 6;
            if (this.props.chat_open != -1 || this.state.list_open == true) {
                width_candidato_box = (window.innerWidth - 300) / 6;
            }
            let height_candidato_box = (window.innerHeight - 0) / 4;
            this.setState({ width_candidato_box, height_candidato_box });
        }

        return;
        if (this.state.sala_select.alunos != undefined && state.sala_select.alunos != undefined) {
            console.log('entrou');
            let actual_ids = Object.values(this.state.sala_select.alunos).sort(this.sort_by_online.bind(this)).filter((item, id) => this.state.number_online.includes(item.id.toString())).map((item, id) => item.id);
            let last_ids = Object.values(state.sala_select.alunos).sort(this.sort_by_online.bind(this)).filter((item, id) => state.number_online.includes(item.id.toString())).map((item, id) => item.id);
            let arrays_equal = true;
            // console.log(actual_ids)
            // console.log(last_ids)
            if (actual_ids.length != last_ids.length) {
                arrays_equal = false;
            }
            else {
                for (let i = 0; i < actual_ids.length; i++) {
                    if (actual_ids[i] != last_ids[i]) {
                        arrays_equal = false;
                        break
                    }
                }
            }
            if (arrays_equal == false) {
                // console.log('Diferente');
                Object.values(this.state.sala_select.alunos).map((item, id) => {
                    try {

                        if (document.getElementById(item.id) != null) {
                            document.getElementById(item.id).srcObject = item.stream
                            if (!this.state.number_online.includes(item.id.toString())) {
                                if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                    this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                    this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                    this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                                }
                            }
                            else if (this.audio_context_peers[item.id] != undefined) {
                                if (this.audio_context_peers[item.id].isInTime != true) {
                                    if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                        this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                        this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                        this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                                    }
                                }
                                else {
                                    if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                        this.state.sala_select.alunos[item.id].bar1.current.hidden = false;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                        this.state.sala_select.alunos[item.id].bar2.current.hidden = false;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                        this.state.sala_select.alunos[item.id].bar3.current.hidden = false;
                                    }
                                }
                            }
                            else {
                                if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                    this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                    this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                    this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                                }
                            }
                        }
                        else {
                            if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                            }
                            if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                            }
                            if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                            }
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                })
            }

        }
    }

    componentWillUnmount() {
        this.unmont = true;
        Object.keys(this.audio_context_peers).forEach(id => this.stopPeerAudio(id));
        // window.removeEventListener('mousemove', this.mouseEvent)
        window.removeEventListener('resize', this.resizeEvent, true);
        this.props.mudarSalaScreen(false);

        clearTimeout(this.logs_timeout);
        clearTimeout(this.timeout_numbers);
        clearTimeout(this.timeout_room_status);
        if (this.socket != undefined) {
            this.socket.close();
        }
        this.props.mudarSocket(null);

    }

    async get_salas(id) {
        this.setState({ loading_screen: true });
        getRooms(id, this.props.token).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_salas(this.props.match.params.id);
                    }, 5000);
                }
                else if (this.unmont == false) {
                    this.props.mudarProcesso(resp.processo);
                    let salas_ids = [];
                    let salas_numbers = {}
                    let candidatos = [];
                    let comunicados = [];
                    for (let i = 0; i < resp.comunicados.length; i++) {
                        resp.comunicados[i].send = true;
                        comunicados.push(resp.comunicados[i]);
                    }
                    if (resp.salas.length == 0) {
                        this.setState({ redirect: true });
                        return;
                    }
                    for (let i = 0; i < resp.salas.length; i++) {
                        let alunos = {};
                        salas_ids.push(resp.salas[i].id);
                        salas_numbers[resp.salas[i].id] = resp.salas[i].numero;
                        // let alunos_lista=[];
                        for (let j = 0; j < resp.salas[i].alunos.length; j++) {
                            candidatos.push({ name: resp.salas[i].alunos[j].name + ' - Sala ' + resp.salas[i].numero, id: resp.salas[i].alunos[j].id, sala_id: resp.salas[i].id });
                            alunos[resp.salas[i].alunos[j].id] = resp.salas[i].alunos[j];
                            alunos[resp.salas[i].alunos[j].id].videoRef = React.createRef();
                            alunos[resp.salas[i].alunos[j].id].bar1 = React.createRef();
                            alunos[resp.salas[i].alunos[j].id].bar2 = React.createRef();
                            alunos[resp.salas[i].alunos[j].id].bar3 = React.createRef();
                            alunos[resp.salas[i].alunos[j].id].desconectado = true;
                        }
                        resp.salas[i].alunos = alunos;
                    }
                    candidatos = candidatos.sort(function (a, b) { return a.name - b.name });
                    this.setState({ candidatos: candidatos, salas_numbers, loading_screen: false, salas_ids, comunicados: comunicados, salas: resp.salas, sala_select: { ...resp.salas[0] }, alunos_m: resp.alunos }, () => {
                        clearTimeout(this.timeout_numbers);
                        this.get_numbers();
                    });
                    this.video_init();
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_salas(this.props.match.params.id);
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_salas(this.props.match.params.id);
                }, 5000);
            });
    }



    async get_sala(id, sala_id, last_sala) {
        this.setState({ loading_sala: true });
        getRoom(id, sala_id, this.props.token).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_sala(this.props.match.params.id, sala_id);
                    }, 5000);
                }
                else if (this.unmont == false) {
                    if (sala_id == this.state.sala_select.id) {
                        this.props.mudarProcesso(resp.processo);
                        let salas_ids = [];
                        let candidatos = [];
                        let comunicados = [];
                        for (let i = 0; i < resp.comunicados.length; i++) {
                            resp.comunicados[i].send = true;
                            comunicados.push(resp.comunicados[i]);
                        }
                        if (resp.salas.length == 0) {
                            this.setState({ redirect: true });
                            return;
                        }
                        for (let i = 0; i < resp.salas.length; i++) {
                            let alunos = {};
                            salas_ids.push(resp.salas[i].id);
                            // let alunos_lista=[];
                            for (let j = 0; j < resp.salas[i].alunos.length; j++) {
                                candidatos.push({ name: resp.salas[i].alunos[j].name + ' - Sala ' + resp.salas[i].numero, id: resp.salas[i].alunos[j].id, sala_id: resp.salas[i].id });
                                alunos[resp.salas[i].alunos[j].id] = resp.salas[i].alunos[j];
                                alunos[resp.salas[i].alunos[j].id].videoRef = React.createRef();
                                alunos[resp.salas[i].alunos[j].id].bar1 = React.createRef();
                                alunos[resp.salas[i].alunos[j].id].bar2 = React.createRef();
                                alunos[resp.salas[i].alunos[j].id].bar3 = React.createRef();
                                alunos[resp.salas[i].alunos[j].id].desconectado = true;
                            }
                            resp.salas[i].alunos = alunos;
                        }
                        this.setState({ alunoChat_select: {}, loading_sala: false, sala_select: { ...resp.salas[0] }, video_blink: {}, video_blink_movement: {}, alunos_m: { ...this.state.alunos_m, ...resp.alunos } }, () => {
                            console.log('teste');
                            if (sala_id == this.state.sala_select.id) {
                                clearTimeout(this.timeout_numbers);
                                this.get_numbers();
                                // console.log({ name: 'Admin',  sala_id: this.state.sala_select, last_sala, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id })
                                this.scheduleRoomStatusFallback(this.state.sala_select.id);
                                this.socket.emit('change_room', { name: 'Admin', processo_id: this.props.processo.id, sala_id: this.state.sala_select.id, last_sala, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

                            }

                        });
                    }
                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_sala(this.props.match.params.id, sala_id);
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_sala(this.props.match.params.id, sala_id);
                }, 5000);
            });
    }

    getChatOnlineCandidates() {
        const cache = this.chat_online_cache;
        const processoId = this.props.processo?.id;
        if (cache && cache.number_online === this.state.number_online && cache.salas_ids === this.state.salas_ids &&
            cache.processo_id === processoId && cache.status_revision === this.external_camera_status_revision) {
            return cache.ids;
        }
        const salas = cache && cache.salas_ids === this.state.salas_ids
            ? cache.salas : new Set(this.state.salas_ids.map(String));
        const ids = processoId == null ? [] : this.state.number_online.filter(id => {
            const status = this.external_camera_status[id];
            return status != null && status.processo_id == processoId && salas.has(String(status.sala_id));
        });
        this.chat_online_cache = { number_online: this.state.number_online, salas_ids: this.state.salas_ids,
            processo_id: processoId, status_revision: this.external_camera_status_revision, salas, ids };
        return ids;
    }

    getOnlineCandidates() {
        const chatOnline = this.getChatOnlineCandidates();
        const cache = this.online_candidates_cache;
        if (cache && cache.chat_online === chatOnline && cache.peer_version === this.peer_version) return cache.ids;
        const ids = chatOnline.filter(id => this.list_peers[id] != null);
        this.online_candidates_cache = { chat_online: chatOnline, peer_version: this.peer_version, ids };
        return ids;
    }

        sort_by_online(a, b) {
        let number_online = this.getOnlineCandidates();
        // console.log(a.id+' '+b.id)
        // console.log(number_online.includes(a.id.toString()))
        // console.log(number_online.includes(b.id.toString()))
        // console.log(number_online.includes(a.id.toString()) < number_online.includes(b.id.toString()))
        // console.log(number_online.includes(b.id.toString()) > number_online.includes(a.id.toString()))
        // console.log(number_online)


        if (number_online.includes(a.id.toString()) > number_online.includes(b.id.toString())) {
            return -1;
        }
        if (number_online.includes(b.id.toString()) < number_online.includes(a.id.toString())) {
            return 1;
        }
        return 0;
    }

    stopPeerAudio(id) {
        const audio = this.audio_context_peers[id];
        if (!audio) return;
        delete this.audio_context_peers[id];
        clearTimeout(audio.timeout);
        clearTimeout(audio.draw_timeout);
        ['source', 'analyser', 'gainNode'].forEach(key => {
            try { audio[key]?.disconnect(); } catch (e) {}
        });
        try {
            if (audio.context && audio.context.state !== 'closed') {
                const closing = audio.context.close();
                if (closing && typeof closing.catch === 'function') closing.catch(() => {});
            }
        } catch (e) {}
    }

    draw_peer(id, uuid) {
        try {
            let user_id = id;
            if (this.unmont || !this.audio_context_peers[user_id] || this.audio_context_peers[user_id]['id'] != uuid) {
                return;
            }
            if (!this.state.sala_select.alunos?.[id]) {
                this.stopPeerAudio(id);
                return;
            }
            if (this.audio_context_peers[user_id]['context'].state != 'running') {
                this.audio_context_peers[user_id]['context'].resume().catch(() => {});
            }

            if (
                this.state.sala_select.alunos[id]
            ) {

                let bar1 = this.state.sala_select.alunos[id].bar1.current;
                let bar2 = this.state.sala_select.alunos[id].bar2.current;
                let bar3 = this.state.sala_select.alunos[id].bar3.current;
                // console.log(this.state.sala_select.alunos[id])
                // let bar_peer = document.getElementById('indicator'+id);
                // let audio_elem = document.getElementById('audio' + id);

                if (bar1 == null || bar2 == null || bar3 == null) {
                    // console.log('encerrou ' + id)
                    clearTimeout(this.audio_context_peers[id].timeout);
                    if (bar1 != null) {
                        // console.log('hidden')
                        // bar1.hidden = true;
                        // bar2.hidden = true;
                        // bar3.hidden = true;
                        if (this.state.sala_select.alunos[id].bar1 != undefined && this.state.sala_select.alunos[id].bar1.current != null) {
                            this.state.sala_select.alunos[id].bar1.current.hidden = true;
                        }
                        if (this.state.sala_select.alunos[id].bar2 != undefined && this.state.sala_select.alunos[id].bar2.current != null) {
                            this.state.sala_select.alunos[id].bar2.current.hidden = true;
                        }
                        if (this.state.sala_select.alunos[id].bar3 != undefined && this.state.sala_select.alunos[id].bar3.current != null) {
                            this.state.sala_select.alunos[id].bar3.current.hidden = true;
                        }
                    }

                    this.stopPeerAudio(id);
                    return 0;
                }
                const audio = this.audio_context_peers[id];
                audio.analyser.getByteTimeDomainData(audio.dataArray);
                let max = 0;
                for (let i = 0; i < audio.bufferLength; i++) {
                    const level = (audio.dataArray[i] / 128.0 - 0.93) * 100;
                    if (level > max) max = level;
                }

                if (max > 10) {
                    [bar1, bar2, bar3].forEach(bar => {
                        if (bar.hidden) bar.hidden = false;
                    });
                    audio.isInTime = true;
                    clearTimeout(audio.timeout);
                    audio.timeout = setTimeout(() => {
                        if (this.unmont || this.audio_context_peers[id]?.id !== uuid) return;
                        audio.isInTime = false;
                        const aluno = this.state.sala_select.alunos[id];
                        [aluno?.bar1?.current, aluno?.bar2?.current, aluno?.bar3?.current].forEach(bar => {
                            if (bar && !bar.hidden) bar.hidden = true;
                        });
                    }, 10000);
                }

                const heights = [bar2.style.height, bar3.style.height, Math.min(max, 15) + 'px'];
                [bar1, bar2, bar3].forEach((bar, index) => {
                    if (bar.style.height !== heights[index]) bar.style.height = heights[index];
                });

                this.audio_context_peers[id].draw_timeout = setTimeout(() => {
                    this.draw_peer(id, uuid)
                }, 300);
            }
        } catch (error) {
            console.error('Erro no draw_peer do candidato', id, error);
        }
    };


    salvar_log() {
        fetch(`${URL}api/fiscal/salvar_log?screen=sala&sala_numero=${this.state.sala_select.numero}&sala_id=${this.state.sala_select.id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (this.unmont == false) {
                        this.logs_timeout = setTimeout(() => {
                            this.salvar_log();
                        }, 60000);
                    }
                }
            } catch (err) {
                console.log(err);
                if (this.unmont == false) {
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }

            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont == false) {
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }
            });
    }

    onIceCandidate(peer, evt, aluno_id,external) {
        if (evt.candidate) {
            this.socket.emit("candidate_to_aluno", JSON.stringify({ external, "candidate": evt.candidate, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id, aluno_id: aluno_id }));
        }
    }

    video_init() {
        this.admin_id = this.uuidv4();
        const hasEncryptedSocket = hasSocketApiEncryptionKey();
        const socketQuery = { token: this.props.token };
        if (hasEncryptedSocket) {
            socketQuery.encrypted_socket = 'true';
        }
        const socket = io.connect(URL_SOCKET, { "transports": ['websocket'], query: socketQuery });
        this.socket = hasEncryptedSocket ? secureSocket(socket) : socket;
        this.props.mudarSocket(this.socket);

        // socket.emit("join", {name:'Admin',sala_id:sala_id,faculdade_id:faculdade_id});
        this.socket.on("connect", function (client) {
            this.props.changeConnect(true);

            // this.socket.emit('join_stream_admin', { sala_id: this.state.sala_select.id, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id })
            this.socket.emit("join", { name: 'Admin', processo_id: this.props.processo.id, salas_ids: this.state.salas_ids, sala_id: this.state.sala_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

        }.bind(this));


        this.socket.on("send_msg_fiscal", data => {
            this.registerCandidateChatStatus(data);
        });

        this.socket.on("external_camera_status", function (data) {
            if (data != null && this.state.salas_ids.some(id => id == data.sala_id) && (data.processo_id == this.props.processo.id || (data.processo_id == null && data.sala_id == this.state.sala_select.id)) && data.aluno_id != undefined) {
                let external_camera_status = this.external_camera_status;
                this.setExternalCameraStatus(data.aluno_id, data, external_camera_status);
                this.refreshExternalCameraStatus();
            }
        }.bind(this));

        this.socket.on("candidate", function (msg) {
            // console.log("candidate received");
            let id = JSON.parse(msg).aluno_id;
            if(JSON.parse(msg).external==true){
                id+='external_'+id;
            }
            if (this.list_peers[id] != undefined && this.list_peers[id].connectionState != 'closed') {
                this.list_peers[id].addIceCandidate(new RTCIceCandidate(JSON.parse(msg).candidate));
            }

        }.bind(this));

        this.socket.on("sdp" + this.admin_id, function (msg) {
            console.log("sdp received");
            let data = JSON.parse(msg)
            if ((data.processo_id != null && data.processo_id != this.props.processo.id) ||
                (data.sala_id != null && data.sala_id != this.state.sala_select.id) ||
                this.state.sala_select.alunos[data.aluno_id] == undefined) return;
            let id = data.aluno_id;
            let id_ = data.aluno_id;

            if(data.external==true){
                id+='external_'+id;
            }
            this.stopPeerAudio(id);
            if (this.list_peers[id] != undefined) {
                this.list_peers[id].close();
            }
            this.list_peers[id] = new RTCPeerConnection(this.configuration);
            this.peer_version++;
            const peer = this.list_peers[id];
            peer.onconnectionstatechange = () => {
                if (this.unmont || this.list_peers[id] !== peer) return;
                if (['disconnected', 'failed', 'closed'].includes(peer.connectionState)) {
                    this.stopPeerAudio(id);
                    this.list_peers[id] = null;
                    this.peer_version++;
                }
            };

            this.list_peers[id].onicecandidate = function (evt) {
                if (!evt.candidate) return;
                // console.log("onicecandidate called");
                this.onIceCandidate(this.list_peers[id], evt, id_,data.external);
            }.bind(this);

            this.list_peers[id].onaddstream = function (evt) {
                if (this.unmont || this.list_peers[id] !== peer) return;
                console.log("onaddstream called",data);
                if (this.state.sala_select.alunos[id_] != undefined && data.external!=true) {

                    this.state.sala_select.alunos[id_].videoRef.current.srcObject = evt.stream;
                    this.state.sala_select.alunos[id_].stream = evt.stream;

                    let user_id = id;
                    this.stopPeerAudio(user_id);
                    this.audio_context_peers[user_id] = {}
                    this.audio_context_peers[user_id]['context'] = new AudioContext();
                    this.audio_context_peers[user_id]['analyser'] = this.audio_context_peers[user_id]['context'].createAnalyser();
                    this.audio_context_peers[user_id]['frequencyData'] = null;
                    this.audio_context_peers[user_id]['source'] = this.audio_context_peers[user_id]['context'].createMediaStreamSource(this.state.sala_select.alunos[id].stream);
                    this.audio_context_peers[user_id]['source'].connect(this.audio_context_peers[user_id]['analyser']);
                    this.audio_context_peers[user_id]['gainNode'] = this.audio_context_peers[user_id]['context'].createGain();
                    this.audio_context_peers[user_id]['gainNode'].gain.value = 0.1; // setting it to 10%
                    this.audio_context_peers[user_id]['gainNode'].connect(this.audio_context_peers[user_id]['context'].destination);
                    // analyser.connect(context.destination);

                    this.audio_context_peers[user_id]['context'].resume().catch(() => {})
                    this.audio_context_peers[user_id]['analyser'].fftSize = 32;
                    this.audio_context_peers[user_id]['bufferLength'] = this.audio_context_peers[user_id]['analyser'].frequencyBinCount;
                    this.audio_context_peers[user_id]['dataArray'] = new Uint8Array(this.audio_context_peers[user_id]['bufferLength']);
                    this.audio_context_peers[user_id]['analyser'].getByteTimeDomainData(this.audio_context_peers[user_id]['dataArray']);
                    this.audio_context_peers[user_id].id = this.uuidv4()
                    // this.audio.srcObject = evt.stream
                    this.draw_peer(user_id, this.audio_context_peers[user_id].id);

                    console.log('full_screen_added1')
                    // console.log(this.state.aluno_fullscreen,Object.values(this.state.sala_select.alunos)[this.state.aluno_fullscreen]?.id,id)
                    if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == id) {
                        console.log('full_screen_added2')
                        console.log(evt.stream)
                        this.fullscreen_ref.current.srcObject = evt.stream;

                    }
                }
                else if((this.state.sala_select.alunos[id_] != undefined && data.external==true)){
                    // let sala_select = this.state.sala_select;
                    let external_camera_status = this.external_camera_status;
                    this.state.sala_select.alunos[id_].stream_external = evt.stream;
                    this.setExternalCameraStatus(id_, { ...(external_camera_status[id_] || {}), aluno_id: id_, sala_id: this.state.sala_select.id, external_camera_connected: true }, external_camera_status);
                    if (this.last_alter_external[id_] == 'external') {
                        this.state.sala_select.alunos[id_].videoRef.current.srcObject = evt.stream;
                        if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == id_ && this.fullscreen_ref.current != null) {
                            this.fullscreen_ref.current.srcObject = evt.stream;
                        }
                    }
                    // this.refreshExternalCameraStatus({ sala_select });

                    console.log('Connect_external')
                }
                // document.getElementById("video_tag" + data.aluno_id).srcObject = evt.stream;
            }.bind(this);
            // list_peers[id].oniceconnectionstatechange = function() {
            //     console.log(list_peers[id].iceConnectionState);
            // }
            // list_peers[id].onconnectionstatechange = function() {
            //     console.log(list_peers[id].connectionState);
            // }
            var sessionDesc = new RTCSessionDescription(data.sdp);
            this.list_peers[id].setRemoteDescription(sessionDesc);
            this.list_peers[id].createAnswer().then(function (sdp) {
                if (this.good_quality_student[id] != true) {
                    sdp.sdp = this.handle_offer_sdp(sdp)
                }
                else {
                    console.log('NAO ENTROU SDP')
                }
                console.log('anwser sdp');
                this.list_peers[id].setLocalDescription(new RTCSessionDescription(sdp));
                this.socket.emit("answer", JSON.stringify({external:data.external, "sdp": sdp, admin_id: this.admin_id, aluno_id: data.aluno_id, faculdade_id: this.props.faculdade.id }));
            }.bind(this)).catch(function (e) {
                console.log(e);
            });
        }.bind(this));

        this.socket.on("number_line" + this.props.faculdade.id, function (data) {
            if (data.sala_id == this.state.sala_select.id) {
                this.setState({ number_line: data.number_line ? data.number_line : this.state.number_line })

            }
        }.bind(this))

        this.socket.on("aluno_desconectou_" + this.props.faculdade.id, function (data) {
            if (data.aluno_id != undefined) {
                if (data.sala_id == this.state.sala_select.id && !data.number.includes( data.aluno_id.toString())) {

                    this.stopPeerAudio(data.aluno_id);
                    let sala_select = this.state.sala_select;
                    console.log(data);
                    console.log('desconectou');
                    if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == data.aluno_id) {
                        this.fullscreen_ref.current.srcObject = null;
                    }
                    sala_select.alunos[data.aluno_id].desconectado = true;
                    if (sala_select.alunos[data.aluno_id].videoRef.current != null) {
                        sala_select.alunos[data.aluno_id].videoRef.current.srcObject = null;
                    }
                    this.setGoodQualityStudent(data.aluno_id, false);
                    let external_camera_status = this.external_camera_status;
                    this.setExternalCameraStatus(data.aluno_id, { ...(external_camera_status[data.aluno_id] || {}), aluno_id: data.aluno_id, sala_id: data.sala_id, external_camera_connected: false, candidate_inside_screen: true }, external_camera_status);

                    this.refreshExternalCameraStatus({
                        number_online: data.number,
                        number_line: data.number_line ? data.number_line : this.state.number_line,
                        sala_select,
                        video_blink: { ...this.state.video_blink, [data.aluno_id]: false },
                        video_blink_movement: { ...this.state.video_blink_movement, [data.aluno_id]: false }
                    })
                }
                else if(data.number.includes( data.aluno_id.toString())){
                    if (this.state.sala_select.alunos[data.aluno_id]?.videoRef.current != null) {
                        this.state.sala_select.alunos[data.aluno_id].videoRef.current.srcObject = this.state.sala_select.alunos[data.aluno_id].stream;
                    }
                    this.setState({ number_online: data.number })

                }
                else {
                    this.setState({ number_online: data.number })
                }
            }
            else {
                this.setState({ number_online: data.number, number_line: data.number_line ? data.number_line : this.state.number_line })
            }
        }.bind(this))

        this.socket.on("aluno_conectou_" + this.props.faculdade.id, function (data) {
            if (data.aluno_id == null && data.sala_id == this.state.sala_select.id && Array.isArray(data.external_camera_statuses)) {
                clearTimeout(this.timeout_room_status);
            }
            let external_camera_status = this.mergeExternalCameraStatuses(data.external_camera_statuses, this.external_camera_status);
            if (data.aluno_id != undefined && data.processo_id != null) {
                this.setExternalCameraStatus(data.aluno_id, {
                    ...(external_camera_status[data.aluno_id] || {}),
                    aluno_id: data.aluno_id,
                    sala_id: data.sala_id,
                    processo_id: data.processo_id
                }, external_camera_status);
            }
            console.log(data);
            // $('#online_number').text(data.number);
            if (data.aluno_id != undefined) {

                if (data.sala_id == this.state.sala_select.id) {
                    console.log('ENTROU SALA')
                    let video_blink = { ...this.state.video_blink }
                    let video_blink_movement = { ...this.state.video_blink_movement }

                    let keys = Object.keys(video_blink);
                    for (let i = 0; i < keys.length; i++) {
                        if (!data.number.includes(keys[i].toString())) {
                            video_blink[keys[i]] = false;
                        }
                    }

                    keys = Object.keys(video_blink_movement);
                    for (let i = 0; i < keys.length; i++) {
                        if (!data.number.includes(keys[i].toString())) {
                            video_blink_movement[keys[i]] = false;
                        }
                    }

                    let sala_select = this.state.sala_select;
                    sala_select.alunos[data.aluno_id].desconectado = false
                    this.setExternalCameraStatus(data.aluno_id, {
                        ...(external_camera_status[data.aluno_id] || {}),
                        aluno_id: data.aluno_id,
                        sala_id: data.sala_id,
                        candidate_inside_screen: data.candidate_inside_screen !== undefined ? data.candidate_inside_screen == true : true,
                        candidate_ip: data.candidate_ip || data.ip || external_camera_status[data.aluno_id]?.candidate_ip || null
                    }, external_camera_status);

                    this.refreshExternalCameraStatus({ number_online: data.number, number_line: data.number_line, sala_select, video_blink, video_blink_movement })
                }
                else {
                    console.log('NAO ENTROU SALA',data,this.state.sala_select)
                    this.refreshExternalCameraStatus({ number_online: data.number })
                }

            }
            else {
                this.refreshExternalCameraStatus({
                    number_online: data.number,
                    number_line: data.number_line,
                    video_blink: {},
                    video_blink_movement: {}
                })
            }
        }.bind(this))

        this.socket.on('disconnect', function () {
            clearTimeout(this.timeout_room_status);
            console.log('desconectou socket')
            this.props.changeConnect(false);
        }.bind(this));

        //Send the ICE Candidate to the remote peer
        clearTimeout(this.timeout_numbers);
        this.timeout_numbers = setTimeout(() => {
            this.get_numbers();
        }, 300000);

    }

    scheduleRoomStatusFallback(salaId) {
        clearTimeout(this.timeout_room_status);
        if (salaId == null) return;
        this.timeout_room_status = setTimeout(() => {
            if (!this.unmont && this.socket?.connected && this.state.sala_select.id == salaId) {
                this.get_numbers();
            }
        }, 15000);
    }

    get_numbers() {
        if (this.socket != null) {
            this.socket.emit("get_numbers", { processo_id: this.props.processo.id, salas_ids: this.state.salas_ids, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id, sala_id: this.state.sala_select.id });
        }
        clearTimeout(this.timeout_numbers);
        this.timeout_numbers = setTimeout(() => {
            this.get_numbers();
        }, 300000);
    }

    receive_all(uuid, sala_id, aluno_id) {
        fetch(`${URL}api/fiscal/receive_all_fiscal`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uuid,
                sala_id, aluno_id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }

    sendReceive(aluno) {
        let aluno2 = this.state.alunos_m[aluno.id];
        if (aluno2.mensagens.length > 0) {
            this.props.socket.emit('msg_receive_aluno', { sala_id: aluno2.sala_id, aluno_id: aluno2.id, uuid: aluno2.mensagens[aluno2.mensagens.length - 1].uuid, faculdade_id: this.props.faculdade.id });
            this.receive_all(aluno2.mensagens[aluno2.mensagens.length - 1].uuid, aluno2.sala_id, aluno2.id);
        }
        let alunos = { ...this.state.alunos_m };
        alunos[aluno2.id].counter = 0;
        this.setState({ alunos_m: alunos, alunoChat_select: { ...alunos[aluno2.id] } });
    }

    send_message(msg) {
        let uid_msg = this.uuidv4();

        if (msg != null && msg != '' && msg.replace(/ /g, '') != '') {
            this.props.socket.emit("send_msg", { processo_id: this.props.processo.id, msg: msg, sala_id: this.state.alunoChat_select.sala_id, aluno_id: this.state.alunoChat_select.id, nome_chat: this.props.user.name, id_msg: uid_msg, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id, id_adm: this.props.user.id });
            // $(this).val('');
            // $('#body_msg').append(template_send.replace(/%MSG%/g,msg).replace(/%ID%/g,uid_msg));
            // $('#body_msg').scrollTop($('#body_msg')[0].scrollHeight);
            let alunos = { ...this.state.alunos_m };
            // let aluno_select={...this.state.aluno_select};
            // aluno_select.mensagens.push({
            //     sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
            //     receive_id: this.state.aluno_select.id, sala_id:this.state.aluno_select.sala_id, uuid: uid_msg, visto: false, message: msg
            // });
            alunos[this.state.alunoChat_select.id].mensagens.push({
                sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
                receive_id: this.state.alunoChat_select.id, sala_id: this.state.alunoChat_select.sala_id, uuid: uid_msg, visto: undefined, message: msg,
                created_at: moment().format('YYYY-MM-DD HH:mm:ss')

            });
            this.setState({ alunos_m: alunos });
            return true;
        }
        return false;
    }



    get_messages_from_student(id) {
        console.log('id', id)
        console.log(this.state.alunos_m)
        return [...this.state.alunos_m[id].mensagens];
    }

    removeNotificacao(id_msg) {
        let mensagens_notificacao = { ...this.state.mensagens_notificacao };
        delete (mensagens_notificacao[id_msg]);
        this.setState({ mensagens_notificacao });
    }

    removeNotificacaoValidacao(id_msg) {
        let validacao_notificacao = { ...this.state.validacao_notificacao };
        delete (validacao_notificacao[id_msg]);
        this.setState({ validacao_notificacao });
    }

    removeNotificacaoSaidaTela(id_msg) {
        let saida_tela_notificacao = { ...this.state.saida_tela_notificacao };
        delete (saida_tela_notificacao[id_msg]);
        this.setState({ saida_tela_notificacao });
    }



    getExternalPeerId(alunoId) {
        return String(alunoId) + 'external_' + String(alunoId);
    }

    setGoodQualityStudent(alunoId, value) {
        this.good_quality_student[alunoId] = value;
        this.good_quality_student[this.getExternalPeerId(alunoId)] = value;
    }

    isExternalCameraRequired() {
        return this.props.processo.required_camera_external == true || this.props.processo.required_camera_external == 1;
    }

    registerCandidateChatStatus(data) {
        if (!data || data.from_admin === true || data.aluno_id == null ||
            !this.state.salas_ids.some(id => id == data.sala_id) ||
            (data.processo_id != null && data.processo_id != this.props.processo.id)) return;
        this.setExternalCameraStatus(data.aluno_id, {
            ...(this.external_camera_status[data.aluno_id] || {}),
            aluno_id: data.aluno_id,
            sala_id: data.sala_id,
            processo_id: this.props.processo.id
        });
        this.refreshExternalCameraStatus();
    }

    setExternalCameraStatus(id, status, statuses = this.external_camera_status) {
        statuses[id] = status;
        this.external_camera_status_revision++;
    }


    refreshExternalCameraStatus(patch = {}) {
        this.setState(state => ({
            ...patch,
            external_camera_status_version: state.external_camera_status_version + 1
        }));
    }

    mergeExternalCameraStatuses(statuses, currentStatus = this.external_camera_status) {
        if (!Array.isArray(statuses) || statuses.length === 0) {
            return currentStatus;
        }
        let external_camera_status = currentStatus;
        statuses.forEach((status) => {
            if (status != null && status.processo_id == this.props.processo.id && this.state.salas_ids.some(id => id == status.sala_id) && status.aluno_id != undefined) {
                this.setExternalCameraStatus(status.aluno_id, status, external_camera_status);
            }
        });
        return external_camera_status;
    }

    isExternalCameraConnected(alunoId) {
        let status = this.external_camera_status[alunoId];
        return status == true || status?.external_camera_connected == true;
    }

    isCandidateInsideScreen(alunoId) {
        let status = this.external_camera_status[alunoId];
        if (status == null || status.candidate_inside_screen === undefined) {
            return true;
        }
        return status.candidate_inside_screen == true;
    }


    getCandidateAlerts(alunoId, number_online) {
        let alerts = [];
        if (!number_online.includes(alunoId.toString())) {
            return alerts;
        }
        if (this.isExternalCameraRequired() == true && this.isExternalCameraConnected(alunoId) != true) {
            alerts.push('Câmera externa desconectada');
        }
        if (this.isCandidateInsideScreen(alunoId) != true) {
            alerts.push('Candidato fora da tela');
        }
        return alerts;
    }

    toggleCandidateAlertDetails(alunoId) {
        let candidate_alert_details_open = { ...this.state.candidate_alert_details_open };
        candidate_alert_details_open[alunoId] = candidate_alert_details_open[alunoId] != true;
        this.setState({ candidate_alert_details_open });
    }

    getPeerConnectionState(alunoId) {
        return this.list_peers[alunoId]?.connectionState || 'no-peer';
    }

    getCandidateIp(alunoId) {
        let status = this.external_camera_status[alunoId];
        return status?.candidate_ip || status?.ip || null;
    }

    alter_video(aluno) {
        if (this.state.loading_alter_video[aluno.id] != true) {
            let loading_alter_video = { ...this.state.loading_alter_video }
            loading_alter_video[aluno.id] = true;
            this.setState({ loading_alter_video })
            this.socket.emit("alter_video", { aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
            setTimeout(() => {
                let loading_alter_video = { ...this.state.loading_alter_video }
                loading_alter_video[aluno.id] = false;;
                this.setState({ loading_alter_video })
            }, 5000)
        }
    }

    good_quality_student_alter(aluno) {
        if (this.good_quality_student[aluno.id] != true && this.props.processo.good_quality == true) {
            this.setGoodQualityStudent(aluno.id, true);
            console.log(this.good_quality_student)
            this.socket.emit("good_quality", { good: true, aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
        }
    }


    render() {
        const number_online = this.getOnlineCandidates();
        console.log(this.good_quality_student)
        console.log('external_camera_status',this.external_camera_status)
        return (
            <div>
                {/* <HeaderSala showChatGeral={(e) => {
                    this.setState({ show_modal_chat_geral: e });
                }} /> */}

                {this.state.redirect == true && <Redirect to={this.state.path} />}

                {this.state.loading_screen == false && <div className="row">
                    {/* <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.props.faculdade.name}</h4>
                                <p style={{ fontSize: '1rem', color: 'black' }}>Nome do Fiscal: {this.props.user.name}</p>

                                <h4 style={{ color: 'black' }}>Comunicado Geral</h4>


                                <div className="d-flex" style={{ marginBottom: '0.5rem', marginTop: '1rem' }}>
                                    <textarea id="msg_comunicado" placeholder="Escreva um comunicado Geral para enviar aos candidatos" className="form-control" style={{ resize: 'none', height: '100px' }} />
                                    <button className="btn btn-primary" id="enviar_comunicado">
                                        Enviar
                                        </button>
                                </div>

                            </div>
                        </div>
                    </div> */}
                    <div className="col-12">
                        <div className="card" style={{ marginBottom: 0 }}>
                            <div className="card-body" style={{ padding: 0 }}>
                                <div className="row" style={{ padding: '1.25rem' }}>

                                    <div className="col-12" style={{ marginBottom: '1rem' }}>
                                        <div style={{ padding: '1.25rem', position: 'absolute', right: 0 }}>

                                            <Link onClick={() => {
                                                let keys = Object.keys(this.list_peers);
                                                for (let i = 0; i < keys.length; i++) {
                                                    this.stopPeerAudio(keys[i]);
                                                    this.list_peers[keys[i]]?.close();
                                                    this.list_peers[keys[i]] = null;
                                                    this.peer_version++;
                                                }
                                                for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                    if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                    }
                                                }
                                            }} to='/' className="btn btn-secondary btn-outline btn-circle m-r-5" ><i
                                                className="mdi mdi-reply"
                                                style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                    Voltar</i></Link>


                                        </div>


                                        {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <h4 style={{ color: 'black', fontWeight: 'bold' }}>Salas</h4>}
                                        {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <p style={{ color: 'black', whiteSpace: 'pre-line' }}>{this.props.processo.name}
                                        </p>}

                                        {/* {this.props.processo.type_fiscalization != 'all' && <h4 style={{ color: 'black' }}>{this.props.processo.name}</h4>} */}


                                        <div className="m-b-5">
                                            <span style={{ color: 'green', fontSize: 16 }}>Total de candidatos online: <span id="online_number">{this.state.number_online.length}</span></span>
                                        </div>
                                        <div className="m-b-5">
                                            <span style={{ color: 'green', fontSize: 16 }}>Online nesta sala: <span id="online_number">{Object.keys(this.state.sala_select.alunos).filter((item, id) => number_online.includes(item)).length}</span></span>
                                        </div>

                                        <div className="m-b-5">
                                            <p><b>Opções: </b></p>
                                            <div className='row' style={{margin:0}}>
                                                <button onClick={() => {
                                                    let hide_btns = { ...this.state.hide_btns }
                                                    Object.values(this.state.sala_select.alunos).map((aluno, id) => {
                                                        hide_btns[aluno.id] = true;
                                                    })
                                                    this.setState({ hide_btns });
                                                }} className='btn btn-outline-info mr-1 mb-1'>Esconder ações dos candidatos <i className='mdi mdi-arrow-left'></i></button>

                                                <button onClick={() => {
                                                    let hide_btns = { ...this.state.hide_btns }
                                                    Object.values(this.state.sala_select.alunos).map((aluno, id) => {
                                                        hide_btns[aluno.id] = false;
                                                    })
                                                    this.setState({ hide_btns });
                                                }} className='btn btn-outline-success mr-1 mb-1'>Mostrar ações dos candidatos <i className='mdi mdi-arrow-right'></i></button>
                                                <button onClick={() => {
                                                    if (this.state.loading_sala) return;
                                                    this.setState({ list_open: !this.state.list_open })
                                                }} className="btn  btn-outline-info btn-circle mr-1 mb-1" ><i
                                                    className="mdi mdi-group"
                                                    style={{ fontSize: '15px', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                        Lista de Candidatos</i></button>

                                                <button onClick={() => {

                                                    this.setState({ show_notification:!this.state.show_notification });
                                                }} className='btn btn-outline-warning mr-1 mb-1'>{!this.state.show_notification?'Mostrar notificações':'Esconder notificações'}  <i className='mdi mdi-notification-clear-all'></i></button>


                                                <button onClick={() => {

                                                    this.setState({ show_disconnected:!this.state.show_disconnected });
                                                }} className='btn btn-outline-info mr-1 mb-1'>{!this.state.show_disconnected?'Esconder desconectados':'Mostrar desconectados'}  <i className='mdi mdi-notification-clear-all'></i></button>

                                                <button onClick={() => {
                                                    this.setState({ show_candidate_ip: !this.state.show_candidate_ip });
                                                }} className='btn btn-outline-secondary mr-1 mb-1'>{this.state.show_candidate_ip ? 'Ocultar IPs' : 'Mostrar IPs'}  <i className='mdi mdi-ip-network'></i></button>



                                            </div>
                                            <p style={{ marginTop: 10 }}><b>Mensagens: </b></p>
                                            {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <button onClick={() => {
                                                if (this.state.loading_sala) return;

                                                this.setState({ alunoChat_select: { id: 'comunicado', name: 'Mensagem para Sala ' + this.state.sala_select.numero, sala_id: this.state.sala_select.id, numero: this.state.sala_select.numero } });
                                                this.props.mudarChatOpen(0);
                                            }} className="btn btn-success btn-outline btn-circle mr-1 mb-1" ><i
                                                className="mdi mdi-chat"
                                                style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                    Mensagem para sala</i></button>}
                                            {this.props.user.role == 'fiscal_coordenador' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <button onClick={() => {
                                                this.setState({ alunoChat_select: { id: 'comunicado', name: 'Comunicado Geral' } });
                                                this.props.mudarChatOpen(0);
                                            }} className="btn btn-info btn-outline btn-circle mr-1 mb-1" ><i
                                                className="mdi mdi-chat"
                                                style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                    Comunicado geral</i></button>}

                                            {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <button onClick={() => {
                                                this.setState({ show_modal_chat_geral: true });
                                            }} className="btn btn-outline-success btn-outline btn-circle mr-1 mb-1" ><i
                                                className="mdi mdi-chat"
                                                style={{ fontSize: '15px', fontStyle: 'normal', paddingRight: '1rem' }}>
                                                    Chat Geral</i></button>}

                                        </div>

                                        {this.props.processo.interview == true && <div style={{ border: '1px dashed #17a2b8', width: '100%', padding: 5 }}>
                                            <p style={{ color: '#17a2b8', fontSize: 18, textAlign: 'center', marginBottom: 5 }}>Candidatos na fila de apresentação: <span id="online_number"><b>{this.state.number_line?.length}</b></span>  </p>
                                            {this.state.number_line?.length > 0 && <div className='d-flex justify-content-center align-items-center'>
                                                <button onClick={() => {
                                                    this.props.history.push({ pathname: '/presentation/' + this.props.processo.id, search: '?sala_id=' + this.state.sala_select.id })
                                                }} className='btn btn-info'>Falar com o(s) candidato(s) <i className='mdi mdi-call-made'></i></button>
                                            </div>}

                                        </div>}


                                    </div>
                                    {this.state.salas.map((item, id) => (

                                        <div key={id} className="col-3" style={{ marginBottom: '0.5rem' }}>


                                            <a onClick={() => {
                                                if (this.state.loading_sala === true) {
                                                    return;
                                                }
                                                // if(item.id!=this.state.sala_select.id){
                                                let keys = Object.keys(this.list_peers);
                                                let last_sala = this.state.sala_select.id;
                                                for (let i = 0; i < keys.length; i++) {
                                                    this.stopPeerAudio(keys[i]);
                                                    this.list_peers[keys[i]]?.close();
                                                    this.list_peers[keys[i]] = null;
                                                    this.peer_version++;
                                                }
                                                console.log(item);
                                                for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                    if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                    }

                                                }
                                                this.props.mudarChatOpen(-1);
                                                this.good_quality_student = {};

                                                this.setState({ sala_select: item, alunoChat_select: {}, video_blink: {}, video_blink_movement: {}, list_open: false }, () => {
                                                    this.get_sala(this.props.match.params.id, item.id, last_sala);
                                                });
                                                // }
                                            }} style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', border: this.state.sala_select.id == item.id ? '1px solid green' : '1px solid grey' }}>
                                                <span style={{ color: this.state.sala_select.id == item.id ? 'green' : 'grey' }}>Sala {item.numero}</span>
                                                <div >
                                                    {/* <div className="msg_count" style="position: absolute;right:20px;top:10px">
                                        <span>Nova</span>
                                    </div> */}
                                                </div>


                                            </a>

                                        </div>
                                    ))}
                                </div>
                                <hr />

                                {this.state.loading_sala == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                    <div className="spinner-border text-primary" role="status"  >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div></div>}





                                {this.state.loading_sala == false && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <div className="row" style={{ margin: 0, marginRight: this.props.chat_open != -1 || this.state.list_open ? 300 : 0 }}>
                                    {Object.values(this.state.sala_select.alunos).map((aluno, id) => (
                                        this.state.alunos_m[aluno.id] != undefined && <div key={id}
                                            // onClick={() => {
                                                hidden={this.state.show_disconnected==true && !number_online.includes(aluno.id.toString())}

                                            //     this.setState({ full_screen_open: true, aluno_fullscreen: id });
                                            //     this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                            // }}
                                            className={(number_online.includes(aluno.id.toString()) && (this.state.video_blink[aluno.id] == true || this.getCandidateAlerts(aluno.id, number_online).length > 0)) ? 'blink' : ((number_online.includes(aluno.id.toString()) && this.state.alunos_m[aluno.id].request_validation != null && this.state.alunos_m[aluno.id].request_validation?.approved == null) ? 'blink_face' : '')}
                                            style={{ position: 'relative', padding: 0, flex: "1 0 16%", maxWidth: this.state.width_candidato_box, height: this.state.height_candidato_box, display: 'flex', justifyContent: 'center', marginTop: '0rem', border: '0.5px solid grey' }}>
                                            <div className={"coluna_video"}
                                                style={{ width: '100%', height: '100%', background: 'black' }}>
                                                {!number_online.includes(aluno.id.toString()) && <div className="desconectado{{$aluno->id}}"
                                                    style={{ height: '100%', width: '100%', background: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                                                    <p style={{ color: 'white', fontSize: '14px' }}>Desconectado...</p>
                                                </div>}
                                                <div style={{ borderRadius: 8, height: '100%', display: 'flex' }} className="align-items-center">
                                                    <video id={aluno.id} ref={aluno.videoRef} className="video_tag_aluno" autoPlay muted style={{ zIndex: !number_online.includes(aluno.id.toString()) ? -1 : 'inherit', width: '100%',maxHeight:'100%', position: 'absolute', borderRadius: 8 }} ></video>
                                                </div>
                                                {number_online.includes(aluno.id.toString()) && this.state.video_blink_movement[aluno.id] == true && <div className="blink_background" style={{ position: 'absolute', bottom: 30, left: 10 }}>
                                                    <p style={{ marginBottom: 0, fontSize: 10, color: 'white', marginLeft: 4, marginRight: 4 }}>Múltipas faces</p>
                                                </div>}
                                                {this.state.alunos_m[aluno.id].requests.filter((item) => item.started != null && item.pause_end == null).length > 0 && <div className="blink_pause" style={{ position: 'absolute', bottom: 30, right: 10 }}>
                                                    <p style={{ marginBottom: 0, fontSize: 10, color: 'white', marginLeft: 4, marginRight: 4 }}>{moment().diff(moment(this.state.alunos_m[aluno.id].requests.filter((item) => item.started != null && item.pause_end == null)[0].started).add('seconds', this.state.alunos_m[aluno.id].requests.filter((item) => item.started != null && item.pause_end == null)[0].time), 'seconds') > 0 ? 'Atraso para voltar' : 'Em Pausa'}</p>
                                                </div>}
                                                <div
                                                    style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 11 }}>
                                                    <div hidden className={"bar1" + aluno.id} ref={aluno.bar1} id="bar1_principal"
                                                        style={{ width: '4px', height: '0px', borderRadius: '100px', border: '0.5px solid black', backgroundColor: 'yellow', marginRight: '1px' }}>
                                                    </div>
                                                    <div hidden className={"bar2" + aluno.id} ref={aluno.bar2} id="bar2_principal"
                                                        style={{ width: '4px', height: '0px', borderRadius: '100px', border: '0.5px solid black', backgroundColor: 'yellow', marginRight: '1px' }}>
                                                    </div>
                                                    <div hidden className={"bar3" + aluno.id} ref={aluno.bar3} id="bar3_principal"
                                                        style={{ width: '4px', height: '0px', borderRadius: '100px', border: '0.5px solid black', backgroundColor: 'yellow', marginRight: '1px' }}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ position: 'absolute', color: 'white', boxShadow: '0px 1px 3px 0px rgb(60 64 67 / 30%), 0px 4px 8px 3px rgb(60 64 67 / 15%)', borderRadius: 8, background: 'rgba(0,0,0,0.5)', right: 0, left: 0, bottom: 0, height: 'auto', padding: 5 }}>
                                                <p style={{ margin: 0, fontSize: 12 }}>{aluno.name}</p>
                                                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6, marginTop: 3 }}>
                                                    {/* <PeerConnectionBadge state={this.getPeerConnectionState(aluno.id)} /> */}
                                                    {this.state.show_candidate_ip == true && this.getCandidateIp(aluno.id) != null && <span style={{ fontSize: 11, color: '#6ee7ff', fontWeight: 'bold' }}>IP: {this.getCandidateIp(aluno.id)}</span>}
                                                </div>
                                            </div>
                                            <div style={{ position: 'absolute', color: 'white', boxShadow: '0px 1px 3px 0px rgb(60 64 67 / 30%), 0px 4px 8px 3px rgb(60 64 67 / 15%)', borderRadius: 8, background: 'rgba(0,0,0,0.5)', right: 0, left: 0, top: 0, height: 'auto', padding: 5 }}>
                                                <div className="row btn_actions" style={{ margin: 0, justifyContent: 'center', alignItems: 'center' }}>
                                                    {this.props.processo.chat_type != 'none' && <div data-tip={"Abrir o chat com o candidato " + aluno.name + ""} className="icon_box" style={{ position: 'relative', marginRight: 2 }} onClick={(e) => {
                                                        // e.stopPropagation();
                                                        if (this.state.loading_sala === true) {
                                                            return;
                                                        }

                                                        this.sendReceive(aluno);

                                                        this.props.mudarChatOpen(0);
                                                    }}>
                                                        <ReactTooltip />

                                                        <i style={{ color: 'inherit' }} className="mdi mdi-chat"></i>
                                                        {this.state.alunos_m[aluno.id] != undefined && this.state.alunos_m[aluno.id].counter > 0 && <div style={{
                                                            // padding: '2px',
                                                            // paddingTop: '3px',
                                                            // height:15,
                                                            minWidth: 20,
                                                            background: 'rgb(75, 181, 67)',
                                                            borderRadius: '50px',
                                                            position: 'absolute',
                                                            top: -5,
                                                            textAlign: 'center',
                                                            // paddingBottom: '3px',
                                                            right: -5
                                                        }}>

                                                            <span style={{ color: 'white', textAlign: 'center', fontSize: 11 }}>{this.state.alunos_m[aluno.id].counter}</span>
                                                        </div>}
                                                    </div>}
                                                    {this.props.processo.chat_type != 'none' && <div data-tip={"Visualizar solicitações do candidato " + aluno.name + ""} className="icon_box" style={{ position: 'relative', marginRight: 2 }} onClick={(e) => {
                                                        // e.stopPropagation();
                                                        if (this.state.loading_sala === true) {
                                                            return;
                                                        }

                                                        this.setState({ alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                        this.props.mudarChatOpen(1);
                                                    }}>
                                                        <ReactTooltip />

                                                        <i style={{ color: 'inherit' }} className="mdi mdi-pause-circle"></i>
                                                        {this.state.alunos_m[aluno.id] != undefined && (this.state.alunos_m[aluno.id].requests.length > 0 &&
                                                            this.state.alunos_m[aluno.id].requests[this.state.alunos_m[aluno.id].requests.length - 1].approved == null
                                                        ) && <div style={{
                                                            // padding: '2px',
                                                            // paddingTop: '3px',
                                                            // height:15,
                                                            minWidth: 20,
                                                            background: '#17a2b8',
                                                            borderRadius: '50px',
                                                            position: 'absolute',
                                                            top: -5,
                                                            textAlign: 'center',
                                                            // paddingBottom: '3px',
                                                            right: -5
                                                        }}>

                                                                <span style={{ color: 'white', textAlign: 'center', fontSize: 11 }}>1</span>
                                                            </div>}
                                                    </div>}

                                                    {this.state.hide_btns[aluno.id] != true && <div data-tip={"Número de vezes que o candidato " + aluno.name + " saiu da tela"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        <span style={{ color: this.state.alunos_m[aluno.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length > 0 ? 'yellow' : 'white', textAlign: 'center', fontSize: 11 }}>{this.state.alunos_m[aluno.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length}</span>

                                                    </div>}

                                                    {this.state.hide_btns[aluno.id] != true && <div
                                                        onClick={() => {
                                                            this.setState({ full_screen_open: true, aluno_fullscreen: aluno.id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                            this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                                        }}
                                                        data-tip={"Ver candidato em tela cheia para ouví-lo"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        <i style={{ color: 'inherit' }} className="mdi mdi-fullscreen"></i>

                                                    </div>}

                                                    {this.state.hide_btns[aluno.id] != true && this.props.processo.screen_sharing == true && <div
                                                        onClick={() => {
                                                            // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                            // this.fullscreen_r    ef.current.srcObject = aluno.videoRef.current.srcObject;
                                                            this.alter_video(aluno)
                                                        }}
                                                        data-tip={"Alterar o vídeo do candidato para a webcam ou tela compartilhada"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        {this.state.loading_alter_video[aluno.id] != true && <i style={{ color: 'inherit' }} className="mdi mdi-monitor-multiple"></i>}
                                                        {this.state.loading_alter_video[aluno.id] == true && <div className="spinner-border text-primary" role="status" style={{ width: '1rem', height: '1rem', margin: 0 }} >
                                                        </div>}

                                                    </div>}

                                                    {this.state.hide_btns[aluno.id] != true  && <div
                                                        onClick={() => {
                                                            // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                            // this.fullscreen_r    ef.current.srcObject = aluno.videoRef.current.srcObject;
                                                            // this.alter_video(aluno)
                                                            if(this.last_alter_external[aluno.id]=='external'){
                                                                aluno.videoRef.current.srcObject = aluno.stream;
                                                                this.last_alter_external[aluno.id]='camera';
                                                            }
                                                            else if(aluno.stream_external!=undefined){
                                                                aluno.videoRef.current.srcObject = aluno.stream_external
                                                                this.last_alter_external[aluno.id]='external';
                                                            }
                                                            else{
                                                                aluno.videoRef.current.srcObject = aluno.stream;
                                                                this.last_alter_external[aluno.id]='camera';
                                                            }

                                                        }}
                                                        data-tip={"Alterar o vídeo do candidato para a webcam externa"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        {this.state.loading_alter_video[aluno.id] != true && <i style={{ color: 'inherit' }} className="mdi mdi-monitor"></i>}
                                                        {/* {this.state.loading_alter_video[aluno.id] == true && <div className="spinner-border text-primary" role="status" style={{ width: '1rem', height: '1rem', margin: 0 }} >
                                                        </div>} */}

                                                    </div>}

                                                    {this.state.hide_btns[aluno.id] != true && this.getCandidateAlerts(aluno.id, number_online).length > 0 && <div
                                                        onClick={() => this.toggleCandidateAlertDetails(aluno.id)}
                                                        data-tip={this.state.candidate_alert_details_open[aluno.id] == true ? "Ocultar alertas do candidato" : "Ver alertas do candidato"}
                                                        className="icon_box blink"
                                                        style={{ position: 'relative', marginRight: 2, background: '#dc3545', zIndex: 30 }}>
                                                        <ReactTooltip />
                                                        <i style={{ color: 'inherit' }} className="mdi mdi-information-outline"></i>
                                                    </div>}

                                                    {this.state.hide_btns[aluno.id] != true && <div
                                                        onClick={() => {
                                                            this.setState({ candidato_selectAcao: aluno, show_modal_action: true });
                                                            // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                            // this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                                        }}
                                                        data-tip={"Reportar ação do candidato"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        <i style={{ color: 'inherit' }} className="fas fa-exclamation-circle"></i>

                                                    </div>}
                                                    {this.state.hide_btns[aluno.id] != true && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 2 }}>
                                                        {this.state.alunos_m[aluno.id].finish == 'F' && <div data-tip={"Candidato finalizou a avaliação"} style={{ borderRadius: 100, backgroundColor: '#815ae4', height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30, height: 30 }}>
                                                            <p style={{ margin: 0, color: 'white', fontSize: 10 }}>F</p>
                                                            <ReactTooltip />
                                                        </div>}
                                                        {this.state.alunos_m[aluno.id].finish == 'I' && <div data-tip={"Candidato não finalizou a avaliação"} style={{ borderRadius: 100, backgroundColor: 'darkgoldenrod', height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30, height: 30 }}>
                                                            <p style={{ margin: 0, color: 'white', fontSize: 10 }}>NF</p>
                                                            <ReactTooltip />
                                                        </div>}
                                                    </div>}
                                                    {this.state.hide_btns[aluno.id] != true && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div onClick={() => {
                                                            if (this.state.times_reconects[aluno.id] == null) {
                                                                let times_reconects = { ...this.state.times_reconects };

                                                                times_reconects[aluno.id] = moment();
                                                                this.setState({ times_reconects });
                                                                console.log('Reconectando');
                                                                this.socket.emit("reconect_user", { aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

                                                            }
                                                            else {
                                                                if (moment().diff(this.state.times_reconects[aluno.id], 'seconds') > 60) {
                                                                    let times_reconects = { ...this.state.times_reconects };

                                                                    times_reconects[aluno.id] = moment();
                                                                    this.setState({ times_reconects });
                                                                    this.socket.emit("reconect_user", { aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                                                }
                                                                else {
                                                                    console.log(moment().diff(this.state.times_reconects[aluno.id], 'seconds'))
                                                                }

                                                            }
                                                        }} data-tip={"Reconectar com o candidato"} className="icon_box" style={{ position: 'relative' }}>
                                                            <i style={{ color: 'inherit' }} className="mdi mdi-reload"></i>
                                                            <ReactTooltip />
                                                        </div>
                                                    </div>}
                                                    {this.state.alunos_m[aluno.id].presence != null && <div
                                                        onClick={() => {
                                                            this.setState({ list_open: !this.state.list_open })

                                                        }}
                                                        data-tip={this.state.alunos_m[aluno.id].presence.presence ? "Candidato marcado como presente" : "Candidato marcado como ausente"} className="icon_box" style={{ position: 'relative', marginRight: 2, background: this.state.alunos_m[aluno.id].presence.presence ? 'green' : 'red' }} >
                                                        <ReactTooltip />
                                                        <i style={{ color: 'inherit' }} className={this.state.alunos_m[aluno.id].presence.presence ? "mdi mdi-check" : "mdi mdi-close"}></i>

                                                    </div>}
                                                    {number_online.includes(aluno.id.toString()) && this.state.alunos_m[aluno.id].request_validation != null && this.state.alunos_m[aluno.id].request_validation?.approved == null && <div
                                                        onClick={() => {
                                                            // this.setState({list_open:!this.state.list_open})
                                                            this.setState({ open_validation_modal: true, validation_student_id: aluno.id });
                                                        }}
                                                        data-tip={"Candidato pediu liberação para o fiscal"} className="icon_box blink_face" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        <i style={{ color: 'inherit' }} className={"mdi mdi-face"}></i>

                                                    </div>}

                                                    {<div
                                                        onClick={() => {
                                                            // this.setState({list_open:!this.state.list_open})
                                                            let hide_btns = { ...this.state.hide_btns };
                                                            hide_btns[aluno.id] = !hide_btns[aluno.id];
                                                            this.setState({ hide_btns })
                                                            // this.setState({open_validation_modal:true,validation_student_id:aluno.id});
                                                        }}
                                                        data-tip={this.state.hide_btns[aluno.id] != true ? "Esconder botões" : "Mostrar botões"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        <i style={{ color: 'inherit' }} className={this.state.hide_btns[aluno.id] != true ? "mdi mdi-arrow-left" : "mdi mdi-arrow-right"}></i>

                                                    </div>}


                                                </div>
                                            </div>
                                            {this.state.candidate_alert_details_open[aluno.id] == true && this.getCandidateAlerts(aluno.id, number_online).length > 0 && <div style={{ position: 'absolute', bottom: 34, left: 6, right: 6, zIndex: 20, maxHeight: 'calc(100% - 82px)', padding: '6px 8px', color: '#721c24', background: 'rgba(255, 255, 255, 0.98)', border: '1px solid #f5c6cb', borderRadius: 4, boxShadow: '0 4px 12px rgba(0,0,0,0.25)', fontSize: 12, fontWeight: 'bold', textAlign: 'left', textTransform: 'uppercase', pointerEvents: 'auto', overflowWrap: 'break-word', overflowY: 'auto' }}>
                                                {this.getCandidateAlerts(aluno.id, number_online).map((alert, idAlert) => (
                                                    <p key={idAlert} style={{ margin: idAlert == 0 ? 0 : '4px 0 0 0', whiteSpace: 'normal' }}>{alert}</p>
                                                ))}
                                            </div>}
                                        </div>
                                    ))}
                                </div>}
                                <div hidden={!this.state.full_screen_open}
                                    style={{ padding: 0, position: 'fixed', top: 0, bottom: 0, left: 0, right: this.props.chat_open != -1 || this.state.list_open ? 300 : 0, zIndex: 1000 }}>
                                    <div className="coluna_video"
                                        style={{ width: '100%', height: '100%', background: 'black' }}>
                                        <div onClick={() => {
                                            console.log('good quality', this.good_quality_student[this.state.alunoChat_select.id])
                                            if (this.good_quality_student[this.state.alunoChat_select.id] && this.props.processo.good_quality == true) {
                                                this.setGoodQualityStudent(this.state.alunoChat_select.id, false);
                                                this.socket.emit("good_quality", { good: false, aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                            }
                                            this.fullscreen_ref.current.srcObject = null;
                                            this.setState({ aluno_fullscreen: -1, full_screen_open: false });

                                        }} style={{ position: 'absolute', top: '10px', right: '10px', color: 'white', zIndex: 5000 }} className="close"><i className="mdi mdi-close" style={{ fontSize: '1.7rem' }}></i></div>
                                        {this.state.alunoChat_select.id != undefined && !number_online.includes(this.state.alunoChat_select.id.toString()) && this.state.aluno_fullscreen != -1 && <div className="desconectado{{$aluno->id}}"
                                            style={{ height: '100%', width: '100%', backgroundColor: 'rgba(0,0,0,1)', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                                            <p style={{ color: 'white', fontSize: '1rem', zIndex: 1 }}>Desconectado...</p>
                                        </div>}
                                        <div style={{ position: 'absolute', top: 48, right: 10, zIndex: 5000, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6, maxWidth: 260 }}>
                                            {this.state.alunoChat_select.id != undefined && this.isExternalCameraRequired() == true && number_online.includes(this.state.alunoChat_select.id.toString()) && this.isExternalCameraConnected(this.state.alunoChat_select.id) != true && <div style={{ padding: '6px 8px', color: '#856404', background: '#fff3cd', border: '1px solid #ffeeba', borderRadius: 4, textAlign: 'right', fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', boxShadow: '0 2px 8px rgba(0,0,0,0.25)' }}>
                                                Câmera externa desconectada
                                            </div>}
                                            {this.state.alunoChat_select.id != undefined && number_online.includes(this.state.alunoChat_select.id.toString()) && this.isCandidateInsideScreen(this.state.alunoChat_select.id) != true && <div style={{ padding: '6px 8px', color: '#721c24', background: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: 4, textAlign: 'right', fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', boxShadow: '0 2px 8px rgba(0,0,0,0.25)' }}>
                                                Candidato fora da tela
                                            </div>}
                                        </div>
                                        <video ref={this.fullscreen_ref} className="video_tag_aluno" autoPlay style={{ height: '100%', width: '100%', position: 'absolute' }} ></video>
                                        {this.state.alunoChat_select.id != undefined && this.state.aluno_fullscreen != -1 && <p onClick={(e) => {
                                            this.setState({ list_open: !this.state.list_open });
                                        }} style={{ cursor: 'pointer', marginBottom: 0, color: 'black', fontSize: 15, position: 'absolute', top: 10, background: 'white', borderRadius: 10, padding: 2 }}><b>Presença:</b> {this.state.alunos_m[this.state.alunoChat_select.id].presence == null ? (<span style={{ color: 'darkgoldenrod' }}>Não registrado</span>) : (this.state.alunos_m[this.state.alunoChat_select.id].presence.presence ? <span style={{ color: 'green' }}>Presente</span> : <span style={{ color: 'red' }}>Ausente</span>)} <i className='mdi mdi-arrow-right'></i></p>}
                                    </div>
                                    {/* <div onClick={() => {
                                        if (this.state.aluno_fullscreen == 0) {
                                            let indice = Object.values(this.state.sala_select.alunos).length - 1;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                        else {
                                            let indice = this.state.aluno_fullscreen - 1;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                    }} style={{ position: 'absolute', top: '50%', left: '10px', color: 'white', zIndex: 5000 }} className="close"><i className="mdi mdi-arrow-left-thick" style={{ fontSize: '1.7rem' }}></i></div>

                                    <div onClick={() => {
                                        if (this.state.aluno_fullscreen == Object.values(this.state.sala_select.alunos).length - 1) {
                                            let indice = 0;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                        else {
                                            let indice = this.state.aluno_fullscreen + 1;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                    }} style={{ position: 'absolute', top: '50%', right: '10px', color: 'white', zIndex: 5000 }} className="close"><i className="mdi mdi-arrow-right-thick" style={{ fontSize: '1.7rem' }}></i></div> */}

                                    {/* <div style={{ position: 'absolute', color: 'white', background: 'black', right: 0, left: 0, bottom: 0 }}>
                                        {this.state.aluno_fullscreen != -1 && <p style={{ textAlign: 'center', margin: 0 }}>({this.state.aluno_fullscreen + 1}/{Object.keys(this.state.sala_select.alunos).length}) - {Object.values(this.state.sala_select.alunos)[this.state.aluno_fullscreen].name}</p>}
                                    </div> */}
                                    {this.state.alunoChat_select.mensagens != undefined && <div style={{ position: 'absolute', color: 'white', boxShadow: '0px 1px 3px 0px rgb(60 64 67 / 30%), 0px 4px 8px 3px rgb(60 64 67 / 15%)', borderRadius: 8, background: 'rgba(0,0,0,0.5)', right: 0, left: 0, bottom: 0, height: 'auto', padding: 5 }}>
                                        <p style={{ margin: 0 }}>{this.state.alunoChat_select.name}</p>
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6, marginTop: 3 }}>
                                                    {/* <PeerConnectionBadge state={this.getPeerConnectionState(this.state.alunoChat_select.id)} /> */}
                                                    {this.state.show_candidate_ip == true && this.getCandidateIp(this.state.alunoChat_select.id) != null && <span style={{ fontSize: 12, color: '#6ee7ff', fontWeight: 'bold' }}>IP: {this.getCandidateIp(this.state.alunoChat_select.id)}</span>}
                                                </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>

                                                {this.props.processo.chat_type != 'none' && <div data-tip={"Abrir o chat com o candidato " + this.state.alunoChat_select.name + ""} className="icon_box" style={{ position: 'relative', marginRight: 2 }} onClick={(e) => {
                                                    // e.stopPropagation();
                                                    let aluno2 = this.state.alunos_m[this.state.alunoChat_select.id];
                                                    this.sendReceive(aluno2);

                                                    this.props.mudarChatOpen(0);
                                                }}>
                                                    <ReactTooltip />

                                                    <i style={{ color: 'inherit' }} className="mdi mdi-chat"></i>
                                                    {this.state.alunos_m[this.state.alunoChat_select.id] != undefined && this.state.alunos_m[this.state.alunoChat_select.id].counter > 0 && <div style={{
                                                        // padding: '2px',
                                                        // paddingTop: '3px',
                                                        // height:15,
                                                        minWidth: 20,
                                                        background: 'rgb(75, 181, 67)',
                                                        borderRadius: '50px',
                                                        position: 'absolute',
                                                        top: -5,
                                                        textAlign: 'center',
                                                        // paddingBottom: '3px',
                                                        right: -5
                                                    }}>

                                                        <span style={{ color: 'white', textAlign: 'center', fontSize: 11 }}>{this.state.alunos_m[this.state.alunoChat_select.id].counter}</span>
                                                    </div>}
                                                </div>}

                                                {this.props.processo.chat_type != 'none' && <div data-tip={"Visualizar solicitações do candidato " + this.state.alunos_m[this.state.alunoChat_select.id].name + ""} className="icon_box" style={{ position: 'relative', marginRight: 2 }} onClick={(e) => {
                                                    // e.stopPropagation();
                                                    if (this.state.loading_sala === true) {
                                                        return;
                                                    }
                                                    let aluno2 = this.state.alunos_m[this.state.alunoChat_select.id];
                                                    this.setState({ alunoChat_select: { ...aluno2 } });

                                                    this.props.mudarChatOpen(1);
                                                }}>
                                                    <ReactTooltip />

                                                    <i style={{ color: 'inherit' }} className="mdi mdi-pause-circle"></i>
                                                    {this.state.alunos_m[this.state.alunoChat_select.id] != undefined && (this.state.alunos_m[this.state.alunoChat_select.id].requests.length > 0 &&
                                                        this.state.alunos_m[this.state.alunoChat_select.id].requests[this.state.alunos_m[this.state.alunoChat_select.id].requests.length - 1].approved == null
                                                    ) && <div style={{
                                                        // padding: '2px',
                                                        // paddingTop: '3px',
                                                        // height:15,
                                                        minWidth: 20,
                                                        background: '#17a2b8',
                                                        borderRadius: '50px',
                                                        position: 'absolute',
                                                        top: -5,
                                                        textAlign: 'center',
                                                        // paddingBottom: '3px',
                                                        right: -5
                                                    }}>

                                                            <span style={{ color: 'white', textAlign: 'center', fontSize: 11 }}>1</span>
                                                        </div>}
                                                </div>}

                                                <div data-tip={"Número de vezes que o candidato " + this.state.alunoChat_select.name + " saiu da tela"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <span style={{ color: this.state.alunos_m[this.state.alunoChat_select.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length > 0 ? 'yellow' : 'white', textAlign: 'center', fontSize: 11 }}>{this.state.alunos_m[this.state.alunoChat_select.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length}</span>

                                                </div>
                                                {this.props.processo.screen_sharing == true && <div
                                                    onClick={() => {
                                                        // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                        // this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                                        if (this.state.loading_alter_video[this.state.alunoChat_select.id] != true) {
                                                            let loading_alter_video = { ...this.state.loading_alter_video }
                                                            loading_alter_video[this.state.alunoChat_select.id] = true;
                                                            this.setState({ loading_alter_video })
                                                            this.socket.emit("alter_video", { aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                                            setTimeout(() => {
                                                                let loading_alter_video = { ...this.state.loading_alter_video }
                                                                loading_alter_video[this.state.alunoChat_select.id] = false;;
                                                                this.setState({ loading_alter_video })
                                                            }, 5000)
                                                        }
                                                    }}
                                                    data-tip={"Alterar o vídeo do candidato para a webcam ou tela compartilhada"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    {this.state.loading_alter_video[this.state.alunoChat_select.id] != true && <i style={{ color: 'inherit' }} className="mdi mdi-monitor-multiple"></i>}
                                                    {this.state.loading_alter_video[this.state.alunoChat_select.id] == true && <div className="spinner-border text-primary" role="status" style={{ width: '1rem', height: '1rem', margin: 0 }} >
                                                    </div>}

                                                </div>}

                                                {<div
                                                        onClick={() => {
                                                            // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                            // this.fullscreen_r    ef.current.srcObject = aluno.videoRef.current.srcObject;
                                                            // this.alter_video(aluno)
                                                            console.log(this.state.sala_select.alunos[this.state.alunoChat_select.id])
                                                            if(this.last_alter_external[this.state.alunoChat_select.id]=='external'){
                                                                this.state.sala_select.alunos[this.state.alunoChat_select.id].videoRef.current.srcObject = this.state.sala_select.alunos[this.state.alunoChat_select.id].stream;
                                                                this.fullscreen_ref.current.srcObject=this.state.sala_select.alunos[this.state.alunoChat_select.id].stream;

                                                                this.last_alter_external[this.state.alunoChat_select.id]='camera';
                                                            }
                                                            else if(this.state.sala_select.alunos[this.state.alunoChat_select.id].stream_external!=undefined){
                                                                this.state.sala_select.alunos[this.state.alunoChat_select.id].videoRef.current.srcObject = this.state.sala_select.alunos[this.state.alunoChat_select.id].stream_external
                                                                this.fullscreen_ref.current.srcObject=this.state.sala_select.alunos[this.state.alunoChat_select.id].stream_external;
                                                                this.last_alter_external[this.state.alunoChat_select.id]='external';
                                                            }
                                                            else{
                                                                this.state.sala_select.alunos[this.state.alunoChat_select.id].videoRef.current.srcObject = this.state.sala_select.alunos[this.state.alunoChat_select.id].stream;
                                                                this.fullscreen_ref.current.srcObject=this.state.sala_select.alunos[this.state.alunoChat_select.id].stream;

                                                                this.last_alter_external[this.state.alunoChat_select.id]='camera';
                                                            }

                                                        }}
                                                        data-tip={"Alterar o vídeo do candidato para a webcam externa"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                        <ReactTooltip />
                                                        {this.state.loading_alter_video[this.state.alunoChat_select.id] != true && <i style={{ color: 'inherit' }} className="mdi mdi-monitor"></i>}
                                                        {/* {this.state.loading_alter_video[aluno.id] == true && <div className="spinner-border text-primary" role="status" style={{ width: '1rem', height: '1rem', margin: 0 }} >
                                                        </div>} */}

                                                    </div>}

                                                <div
                                                    onClick={() => {
                                                        this.setState({ candidato_selectAcao: this.state.alunoChat_select, show_modal_action: true });
                                                        // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                        // this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                                    }}
                                                    data-tip={"Reportar ação do candidato"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className="fas fa-exclamation-circle"></i>

                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 2 }}>
                                                    {this.state.alunos_m[this.state.alunoChat_select.id].finish == 'F' && <div data-tip={"Candidato finalizou a avaliação"} style={{ borderRadius: 100, backgroundColor: '#815ae4', height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30, height: 30 }}>
                                                        <p style={{ margin: 0, color: 'white', fontSize: 10 }}>F</p>
                                                        <ReactTooltip />
                                                    </div>}
                                                    {this.state.alunos_m[this.state.alunoChat_select.id].finish == 'I' && <div data-tip={"Candidato não finalizou a avaliação"} style={{ borderRadius: 100, backgroundColor: 'darkgoldenrod', height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30, height: 30 }}>
                                                        <p style={{ margin: 0, color: 'white', fontSize: 10 }}>NF</p>
                                                        <ReactTooltip />
                                                    </div>}
                                                </div>
                                                {this.props.processo.good_quality && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <div onClick={() => {
                                                        this.good_quality_student_alter(this.state.alunoChat_select)
                                                    }} data-tip={"Video em boa qualidade"} className="icon_box" style={{ position: 'relative' }}>
                                                        <i style={{ color: 'inherit' }} className="mdi mdi-high-definition"></i>
                                                        <ReactTooltip />
                                                    </div>
                                                </div>}



                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <div onClick={() => {
                                                        if (this.state.times_reconects[this.state.alunoChat_select.id] == null) {
                                                            let times_reconects = { ...this.state.times_reconects };

                                                            times_reconects[this.state.alunoChat_select.id] = moment();
                                                            this.setState({ times_reconects });
                                                            console.log('Reconectando');
                                                            this.socket.emit("reconect_user", { aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

                                                        }
                                                        else {
                                                            if (moment().diff(this.state.times_reconects[this.state.alunoChat_select.id], 'seconds') > 60) {
                                                                let times_reconects = { ...this.state.times_reconects };

                                                                times_reconects[this.state.alunoChat_select.id] = moment();
                                                                this.setState({ times_reconects });
                                                                this.socket.emit("reconect_user", { aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                                            }
                                                            else {
                                                                console.log(moment().diff(this.state.times_reconects[this.state.alunoChat_select.id], 'seconds'))
                                                            }

                                                        }
                                                    }} data-tip={"Reconectar com o candidato"} className="icon_box" style={{ position: 'relative' }}>
                                                        <i style={{ color: 'inherit' }} className="mdi mdi-reload"></i>
                                                        <ReactTooltip />
                                                    </div>
                                                </div>
                                                {this.state.alunos_m[this.state.alunoChat_select?.id]?.presence != null && <div
                                                    onClick={() => {
                                                        this.setState({ list_open: !this.state.list_open })
                                                    }}
                                                    data-tip={this.state.alunos_m[this.state.alunoChat_select.id].presence.presence ? "Candidato marcado como presente" : "Candidato marcado como ausente"} className="icon_box" style={{ position: 'relative', marginRight: 2, background: this.state.alunos_m[this.state.alunoChat_select.id].presence.presence ? 'green' : 'red' }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className={this.state.alunos_m[this.state.alunoChat_select?.id].presence.presence ? "mdi mdi-check" : "mdi mdi-close"}></i>

                                                </div>}
                                                {number_online.includes(this.state.alunoChat_select?.id?.toString()) && this.state.alunos_m[this.state.alunoChat_select?.id]?.request_validation != null && this.state.alunos_m[this.state.alunoChat_select?.id]?.request_validation?.approved == null && <div
                                                    onClick={() => {
                                                        // this.setState({list_open:!this.state.list_open})
                                                        this.setState({ open_validation_modal: true, validation_student_id: this.state.alunoChat_select?.id });
                                                    }}
                                                    data-tip={"Candidato pediu liberação para o fiscal"} className="icon_box blink_face" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className={"mdi mdi-face"}></i>

                                                </div>}
                                            </div>
                                            {this.state.alunoChat_select?.accessibility == true && this.state.alunoChat_select?.type_supervisor != 'none' && <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>

                                                {this.props.socket != null && <button onClick={() => {
                                                    if (this.good_quality_student[this.state.alunoChat_select.id] && this.props.processo.good_quality == true) {
                                                        this.setGoodQualityStudent(this.state.alunoChat_select.id, false);
                                                        this.socket.emit("good_quality", { good: false, aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                                    }
                                                    this.fullscreen_ref.current.srcObject = null;
                                                    this.setState({ full_screen_open: false, aluno_fullscreen: -1, })
                                                    let keys = Object.keys(this.list_peers);
                                                    for (let i = 0; i < keys.length; i++) {
                                                        this.stopPeerAudio(keys[i]);
                                                        this.list_peers[keys[i]]?.close();
                                                        this.list_peers[keys[i]] = null;
                                                        this.peer_version++;
                                                    }
                                                    for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                        if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                            this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                            this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                        }

                                                    }
                                                    this.scheduleRoomStatusFallback(null);
                                                    this.socket.emit('change_room', { name: 'Admin', processo_id: this.props.processo.id, sala_id: null, last_sala: this.state.sala_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

                                                    this.props.changeShowCall(true)
                                                    // this.finishExam();
                                                }} type="button" id="finalizar" className="btn btn-outline-info btn-lg waves-effect waves-light"
                                                >Entrar em chamada<i className='mdi mdi-call-made'></i></button>}

                                            </div>}




                                        </div>
                                    </div>}
                                </div>

                                <div className="row" style={{ margin: 0 }}>
                                    {/* {this.props.processo.type_fiscalization == 'image' && <div className="col-12 ">
                                        {this.props.socket != null && <div style={{ zIndex: 3000, width: '100%' }}> <Chat closeChat={() => {
                                            this.setState({ show_modal_chat_geral: false });
                                        }} alunoChat_select={this.state.alunoChat_select} show_modal_chat_geral={this.state.show_modal_chat_geral} online={this.state.number_online} alunos={this.state.alunos_m} admin_id={this.admin_id} comunicados={this.state.comunicados} mudarState={(data) => {
                                            let state = {}
                                            if (data.alunos != undefined) state.alunos_m = data.alunos;
                                            if (data.comunicados != undefined) state.comunicados = data.comunicados;

                                            this.setState(state);

                                        }} />
                                            <br />
                                            <br />

                                        </div>}
                                    </div>} */}
                                    <div className={this.state.list_open != false ? 'chat_individual_open' : 'chat_individual_close'} style={{ position: 'fixed', zIndex: 1000, maxWidth: 500, top: 0, bottom: 0, width: 300 }}>
                                        <ListStudents getPeerConnectionState={id => this.getPeerConnectionState(id)}
                                            full_screen_open={this.state.full_screen_open}
                                            aluno_fullscreen={this.state.aluno_fullscreen}
                                            list_open={this.state.list_open}
                                            goFullScreen={(aluno) => {
                                                this.setState({ full_screen_open: true, aluno_fullscreen: aluno.id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                this.fullscreen_ref.current.srcObject = this.state.sala_select.alunos[aluno.id].videoRef.current.srcObject;
                                            }}
                                            setListOpen={(e) => {
                                                this.setState({ list_open: e })
                                            }}
                                            sala_select={this.state.sala_select}
                                            alunos_m={this.state.alunos_m}
                                            number_online={number_online}
                                            external_camera_status={this.external_camera_status}
                                            external_camera_status_version={this.state.external_camera_status_version}
                                            mudarState={(data) => {
                                                let state = {}
                                                if (data.alunos_m != undefined) state.alunos_m = data.alunos_m;

                                                this.setState(state);

                                            }}
                                        />
                                    </div>

                                    {this.state.show_notification && <div style={{ position: 'fixed', bottom: '20px', right: '10px', zIndex: 99, width: '300px', display: 'flex', flexDirection: 'column-reverse', whiteSpace: 'pre-wrap' }}
                                        id="msg_notifi">
                                        {Object.values(this.state.mensagens_notificacao).map((item, id) => (

                                            <div onClick={(e) => {
                                                this.removeNotificacao(item.id)
                                                this.setState({ aluno_select_id: item.sender_id, show_modal_chat_geral: true });
                                            }} key={id} className="alert alert-success bg-success text-white border-0 alert-dismissible fade show d-flex" role="alert" style={{ cursor: 'pointer' }}>
                                                <div style={{ marginRight: 10 }}>
                                                    <button onClick={(e) => { e.stopPropagation(); this.removeNotificacao(item.id) }} type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div>

                                                    <strong>Nova mensagem Sala {item.sala_number}</strong>
                                                    <p style={{ margin: 0 }}>Candidato: {item.name}</p>
                                                </div>

                                            </div>
                                        ))}
                                        {Object.values(this.state.saida_tela_notificacao).map((item, id) => (

                                            <div onClick={(e) => {
                                                if (this.state.loading_sala === true || this.state.sala_select.id == item.sala_id) {
                                                    this.removeNotificacaoSaidaTela(item.id)
                                                    return;
                                                }
                                                let sala_new = this.state.salas.filter((item2) => item2.id == item.sala_id)[0]
                                                if (sala_new == undefined) {
                                                    this.removeNotificacaoSaidaTela(item.id)
                                                    return;
                                                }
                                                let keys = Object.keys(this.list_peers);
                                                let last_sala = this.state.sala_select.id;
                                                for (let i = 0; i < keys.length; i++) {
                                                    this.stopPeerAudio(keys[i]);
                                                    this.list_peers[keys[i]]?.close();
                                                    this.list_peers[keys[i]] = null;
                                                    this.peer_version++;
                                                }
                                                for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                    if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                    }
                                                }
                                                this.props.mudarChatOpen(-1);
                                                this.good_quality_student = {};

                                                this.setState({ sala_select: sala_new, alunoChat_select: {}, video_blink: {}, video_blink_movement: {}, list_open: false }, () => {
                                                    this.get_sala(this.props.match.params.id, sala_new.id, last_sala);
                                                });

                                                this.removeNotificacaoSaidaTela(item.id)
                                            }} key={id} className="alert alert-danger bg-danger text-white border-0 alert-dismissible fade show d-flex" role="alert" style={{ cursor: 'pointer' }}>
                                                <div style={{ marginRight: 10 }}>
                                                    <button onClick={(e) => { e.stopPropagation(); this.removeNotificacaoSaidaTela(item.id) }} type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div>
                                                    <strong>Candidato fora da tela</strong>
                                                    <p style={{ margin: 0 }}>Sala {item.sala_number}{item.name ? ' - ' + item.name : ''}</p>
                                                </div>

                                            </div>
                                        ))}
                                        {Object.values(this.state.validacao_notificacao).map((item, id) => (

                                            <div onClick={(e) => {
                                                if (this.state.loading_sala === true || this.state.sala_select.id==item.sala_id) {
                                                    this.removeNotificacaoValidacao(item.id)
                                                    return;
                                                }
                                                let sala_new=this.state.salas.filter((item2)=>item2.id==item.sala_id)[0]
                                                // if(item.id!=this.state.sala_select.id){
                                                let keys = Object.keys(this.list_peers);
                                                let last_sala = this.state.sala_select.id;
                                                for (let i = 0; i < keys.length; i++) {
                                                    this.stopPeerAudio(keys[i]);
                                                    this.list_peers[keys[i]]?.close();
                                                    this.list_peers[keys[i]] = null;
                                                    this.peer_version++;
                                                }
                                                console.log(sala_new);
                                                for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                    if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                    }

                                                }
                                                this.props.mudarChatOpen(-1);
                                                this.good_quality_student = {};

                                                this.setState({ sala_select: sala_new, alunoChat_select: {}, video_blink: {}, video_blink_movement: {}, list_open: false }, () => {
                                                    this.get_sala(this.props.match.params.id, sala_new.id, last_sala);
                                                });

                                                this.removeNotificacaoValidacao(item.id)
                                            }} key={id} className="alert alert-warning bg-warning text-white border-0 alert-dismissible fade show d-flex" role="alert" style={{ cursor: 'pointer' }}>
                                                <div style={{ marginRight: 10 }}>
                                                    <button onClick={(e) => { e.stopPropagation(); this.removeNotificacaoValidacao(item.id) }} type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div>

                                                    <strong>Novo pedido de validação </strong>
                                                    <p style={{ margin: 0 }}>Sala {item.sala_number}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </div>}

                                    {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <div className="col-12 " hidden={this.state.show_modal_chat_geral == false} style={{
                                        position: 'fixed',
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        top: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // background: 'rgba(0,0,0,0.4)',
                                        zIndex: 2000
                                    }}>


                                        {this.props.socket != null && <div style={{ zIndex: 3000, width: '100%' }}> <Chat closeChat={() => {
                                            this.setState({ show_modal_chat_geral: false });
                                        }}
                                            show_chat_meet={this.state.show_chat_meet}
                                            setState={(e) => {
                                                this.setState(e)
                                            }}
                                            chat_open_geral={this.state.chat_open_geral}
                                            aluno_select_id={this.state.aluno_select_id}
                                            removeNotificacao={this.removeNotificacao.bind(this)}
                                            removeNotificacaoValidacao={this.removeNotificacaoValidacao.bind(this)}
                                            removeNotificacaoSaidaTela={this.removeNotificacaoSaidaTela.bind(this)}
                                            current_sala_id={this.state.sala_select.id}
                                            salas_numbers={this.state.salas_numbers}
                                            clearTimeout={(id) => {
                                                let loadings_pause = { ...this.props.loadings_pause }
                                                loadings_pause[id] = false;
                                                clearTimeout(this.timeout_request[id])
                                                let additional = {}
                                                if (this.state.requestSelect?.id == id) {
                                                    additional.show_modal_request = false;
                                                }
                                                this.setState({ loadings_pause, ...additional })
                                            }}
                                            video_blink={this.state.video_blink} video_blink_movement={this.state.video_blink_movement} alunoChat_select={this.state.alunoChat_select} show_modal_chat_geral={this.state.show_modal_chat_geral} online={this.getChatOnlineCandidates()} alunos={this.state.alunos_m} admin_id={this.admin_id} comunicados={this.state.comunicados} mudarState={(data) => {
                                                let state = {}
                                                if (data.alunos != undefined) state.alunos_m = data.alunos;
                                                if (data.comunicados != undefined) state.comunicados = data.comunicados;
                                                if (data.video_blink != undefined) state.video_blink = data.video_blink;
                                                if (data.video_blink_movement != undefined) state.video_blink_movement = data.video_blink_movement;


                                                this.setState(state);

                                            }} /></div>}

                                        <div onClick={() => {
                                            this.setState({ show_modal_chat_geral: false });
                                        }}
                                            style={{
                                                position: 'absolute',
                                                right: 0,
                                                bottom: 0,
                                                left: 0,
                                                top: 0,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                background: 'rgba(0,0,0,0.4)',
                                                zIndex: 2000
                                            }}
                                        >
                                        </div>

                                    </div>}
                                    {this.props.socket != null && this.props.processo.chat_type != 'none' && <div className={this.props.chat_open != -1 ? 'chat_individual_open' : 'chat_individual_close'} style={{ position: 'fixed', zIndex: 1000, maxWidth: 400, top: 0, bottom: 0, width: 300 }}>
                                        <ChatIndividual
                                            send_message={(m) => this.send_message(m)}
                                            loadings_pause={this.state.loadings_pause}
                                            sendReceive={() => {
                                                this.sendReceive(this.state.alunoChat_select);
                                            }}
                                            chat_open={this.props.chat_open} aluno_select={this.state.alunoChat_select} online={this.getChatOnlineCandidates()} alunos={this.state.alunos_m} admin_id={this.admin_id} comunicados={this.state.comunicados} mudarState={(data) => {
                                                let state = {}
                                                if (data.alunos != undefined) state.alunos_m = data.alunos;
                                                if (data.comunicados != undefined) state.comunicados = data.comunicados;
                                                if (data.request != undefined) state.requestSelect = data.request;
                                                if (data.request != undefined) state.show_modal_request = data.show_modal_request;



                                                this.setState(state);

                                            }} />
                                    </div>}

                                    <div className="col-12 col-md-6 d-flex justify-content-center">
                                        <ReportAction setState={(e) => {
                                            this.setState(e);
                                        }} show_modal_action={this.state.show_modal_action} candidatos={this.state.candidatos} sala={this.state.sala_select} candidato_select={this.state.candidato_selectAcao} />
                                    </div>
                                    <SolicitacaoModal
                                        loadings_pause={this.state.loadings_pause}

                                        sendRequestResponse={(data) => {
                                            let loadings_pause = { ...this.state.loadings_pause }
                                            loadings_pause[data.id] = true;
                                            this.setState({ loadings_pause })
                                            console.log('request dada', data)
                                            this.props.socket.emit('request_pause_response', { ...data });
                                            this.timeout_request[data.id] = setTimeout(() => {
                                                let loadings_pause = { ...this.state.loadings_pause }
                                                loadings_pause[data.id] = false;
                                                this.setState({ loadings_pause, message_warning: 'Não foi possível responder a solicitação do candidato ' + data.name + ' da Sala ' + data.sala_numero });
                                            }, 10000);
                                        }}
                                        request={this.state.requestSelect} setState={(e) => {
                                            this.setState(e);
                                        }} show_modal_request={this.state.show_modal_request} sala={this.state.sala_select} candidato_select={this.state.alunoChat_select} />


                                    <ValidationModal
                                        loadings_request_validations={this.state.loadings_request_validations}
                                        number_online={number_online}
                                        onClose={(id) => {
                                            if (this.good_quality_student[id] && this.props.processo.good_quality == true) {
                                                this.setGoodQualityStudent(id, false);
                                                this.socket.emit("good_quality", { good: false, aluno_id: id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                            }
                                        }}
                                        alter_video={(aluno) => this.alter_video(aluno)}
                                        good_quality_student_alter={(aluno) => this.good_quality_student_alter(aluno)}
                                        loading_alter_video={this.state.loading_alter_video}
                                        setState={(e) => {
                                            this.setState(e);
                                        }} open_validation_modal={this.state.open_validation_modal} sala={this.state.sala_select} validation_student_id={this.state.validation_student_id} />




                                </div>
                            </div>
                        </div>
                    </div>
                    <SweetAlert
                        warning
                        title={'Aviso!'}
                        onConfirm={() => this.setState({ message_warning: null })}
                        show={this.state.message_warning != null}
                        confirmBtnText='Entendi'
                        confirmBtnBsStyle="danger"
                    >
                        {this.state.message_warning}
                    </SweetAlert>

                    {this.props.show_call && <MeetingRoom
                        changeStudent={(candidato) => {
                            let candidatos = { ...this.state.alunos_m }
                            candidatos[candidato.id] = candidato;

                            this.setState({ alunos_m: candidatos });
                        }}
                        entrevistas={[]}
                        changeShowChatMeet={(e) => {
                            this.setState({ show_chat_meet: e });
                            if (e == true) {
                                let aluno = this.state.alunoChat_select;
                                if (aluno != undefined) {
                                    this.sendReceive(aluno);
                                }
                            }
                        }}
                        send_message={(m) => this.send_message(m)}
                        getAdminId={() => this.admin_id} processo={this.props.processo} number_online={this.getChatOnlineCandidates()} closeCall={() => {
                            this.props.changeShowCall(false);
                            this.scheduleRoomStatusFallback(this.state.sala_select.id);
                            this.socket.emit('change_room', { name: 'Admin', processo_id: this.props.processo.id, sala_id: this.state.sala_select.id, last_sala: this.state.sala_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

                            this.setState({ alunoChat_select: {} })
                        }}
                        students={Object.values(this.state.alunos_m)}
                        get_messages_from_student={(id) => this.get_messages_from_student(this.state.alunoChat_select.id)}
                        id_candidato={this.state.alunoChat_select?.id}
                        student={this.state.alunoChat_select} />}

                </div>}
                {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    <div className="spinner-border text-primary" role="status"  >
                        <span className="sr-only">Loading...</span>
                    </div>
                </div></div>}
            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        socket: state.AppReducer.socket,
        chat_open: state.AppReducer.chat_open,
        show_call: state.AppReducer.show_call,
    }
);

export default connect(mapsStateToProps, { changeConnect, mudarUser, logout, mudarProcesso, mudarSocket, mudarSalaScreen, mudarChatOpen, changeShowCall })(Sala);
